import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: 'markdown[linkIntercept], .chat__message[linkIntercept]',
  standalone: true
})
export class LinkInterceptorDirective {
  @Input() allowExternal = false;
  @Input() allowedHosts: string[] = [];

  constructor(private router: Router, private el: ElementRef<HTMLElement>) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {    
    const target = event.target as HTMLElement | null;
    const a = target?.closest('a');

    if (!a || !this.el.nativeElement.contains(a)) 
      return;

    const rawHref = a.getAttribute('href') || '';
    if (!rawHref || rawHref.startsWith('#')) 
      return;

    const href = this.toAbsoluteURL(rawHref);
    const isExternal = href.origin !== window.location.origin;
    const isTelOrMail = href.protocol === 'tel:' || href.protocol === 'mailto:';

    if (isTelOrMail || isExternal) 
      return;

    // if (isExternal && !this.allowExternal && !this.isAllowedHost(href)) {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   // aquí tu acción (modal, tracking, etc.)
    //   return;
    // }

    if (!isExternal) {
      event.preventDefault();
      event.stopPropagation();
      this.router.navigateByUrl(href.pathname + href.search + href.hash);
    }
  }

  private toAbsoluteURL(raw: string): URL {
    try { return new URL(raw, window.location.origin); }
    catch { return new URL('/', window.location.origin); }
  }

  private isAllowedHost(url: URL): boolean {
    return this.allowedHosts?.some(h => url.hostname.endsWith(h)) ?? false;
  }
}